import { axios, BaseApiUrl } from '../axios_config';


// 获取移动端签收列表
export const getList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetTFReceiptList`, { ...params }).then(res => res.data)
}

// 获取移动端签收送货明细
export const getDeliveryNo = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetReceiptByDeliveryNo`, { params }).then(res => res.data);
}

// 移动端添加签收图片
export const insertSignForImage = params =>{
    return axios.post(`${BaseApiUrl}/SignFor/InsertSignForImage`, { ...params }).then(res => res.data);
}

// 获取签收图片
export const getSignForImage = params =>{
    return axios.get(`${BaseApiUrl}/SignFor/GetSignForImage`, { params }).then(res => res.data);
}

// 移动端确认签收
export const submitSignFor = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/InsertTFInventoryInfo`, { ...params }).then(res => res.data);
}

